import { render, staticRenderFns } from "./serviceduty.vue?vue&type=template&id=0466f6fc"
import script from "./serviceduty.vue?vue&type=script&lang=js"
export * from "./serviceduty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports